/// #if PLATFORM === 'xd'
<template>
  <div>
    <full-screen v-if="currentStep === 1">
      <div class="container">
        <h3 class="title">Increase the panel width by 2x for better experience</h3>
        <p class="description">Hover your mouse on panel border to increase the panel size.</p>
        <img src="@/assets/onboarding/xd/1.png" width="180" class="image" />
        <button
          type="button"
          uxp-variant="cta"
          @click="currentStep = 2"
        >Next</button>
      </div>
    </full-screen>
    <full-screen v-else-if="currentStep === 2">
      <div class="container">
        <h3 class="title">Add your favourite designer to access their item faster</h3>
        <p class="description">Open designer profile and add it to favourite.</p>
        <img src="@/assets/onboarding/xd/2.png" width="180" class="image" />
        <button
          type="button"
          uxp-variant="cta"
          @click="currentStep = 3"
        >Next</button>
      </div>
    </full-screen>
    <full-screen v-else-if="currentStep === 3">
      <div class="container">
        <h3 class="title">Insert vector icons, illustrations, and stock photos in one click</h3>
        <p class="description">Click on icon and paste it on your Artobard using {{ isWindows ? 'Ctrl' : 'Cmd' }}+V.</p>
        <img src="@/assets/onboarding/xd/3.png" width="180" class="image" />

        <template v-if="isLoggedIn">
          <button
            type="button"
            uxp-variant="cta"
            @click="onClose"
          >Let's Go!</button>
        </template>
        <template v-else>
          <button
            type="button"
            uxp-variant="cta"
            @click="onLogin"
          >Login</button>
          <button
            type="button"
            uxp-variant="secondary"
            uxp-quiet="true"
            @click="onClose"
          >Use as a Guest</button>
        </template>
      </div>
    </full-screen>
  </div>
</template>
/// #else
<template>
  <div>
    <full-screen v-if="currentStep === 1">
      <div class="container">
        <h3 class="title">Access Millions of free and premium design resources</h3>
        <p class="description">Search any item from the large library of icons, illustrations, and stock photos.</p>
        <img src="@/assets/onboarding/1.png" width="280" class="image" />
        <button
          type="button"
          class="btn btn-primary btn-icon"
          @click="currentStep = 2"
        >
          <img src="@/assets/icons/arrow-right.svg" width="24" />
        </button>
      </div>
    </full-screen>
    <full-screen v-else-if="currentStep === 2">
      <div class="container">
        <h3 class="title">Add your favourite designer to access their item faster</h3>
        <p class="description">Select your favourite contributor and access their resources directly.</p>
        <img src="@/assets/onboarding/2.png" width="280" class="image" />
        <button
          type="button"
          class="btn btn-primary btn-icon"
          @click="currentStep = 3"
        >
          <img src="@/assets/icons/arrow-right.svg" width="24" />
        </button>
      </div>
    </full-screen>
    <full-screen v-else-if="currentStep === 3">
      <div class="container">
        <h3 class="title">Insert desired item with just a click</h3>
        <p class="description">Search for the right item and click on it to insert in your design.</p>
        <img src="@/assets/onboarding/3.png" width="280" class="image" />

        <template v-if="isLoggedIn">
          <button
            type="button"
            class="btn btn-primary"
            @click="onClose"
          >Let's Go!</button>
        </template>
        <template v-else>
          <button
            type="button"
            class="btn btn-primary px-4 mt-2"
            @click="onLogin"
          >Login</button>
          <!-- <button
            type="button"
            class="btn btn-link text-muted btn-sm"
            @click="onClose"
          >Use as a Guest</button> -->
        </template>
      </div>
    </full-screen>
  </div>
</template>
/// #endif

<script>
import AuthMixin from '@/components/mixins/auth.js'
import FullScreen from './FullScreen'

export default {
  components: {
    FullScreen
  },

  mixins: [AuthMixin],

  data () {
    return {
      currentStep: 1
    }
  },

  computed: {
    // eslint-disable-next-line
/// #if PLATFORM === 'xd'
    isWindows () {
      const platform = require('os').platform()
      return platform.match(/^win(.)*/) !== null || false
    }
    // eslint-disable-next-line
/// #endif
  },

  methods: {
    onClose () {
      this.$store.commit('settings/setLastVersion')
    },
    onLogin () {
      this.onClose()
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>
